import { render, staticRenderFns } from "./new_product_agreement.vue?vue&type=template&id=4483ad81&scoped=true&"
import script from "./new_product_agreement.vue?vue&type=script&lang=js&"
export * from "./new_product_agreement.vue?vue&type=script&lang=js&"
import style0 from "./new_product_agreement.vue?vue&type=style&index=0&id=4483ad81&lang=less&media=print&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4483ad81",
  null
  
)

export default component.exports